<script lang="ts">
    import { link } from 'svelte-spa-router';
    import { parseBillName, type BillPosition } from '../../api/bills';
    import BillPositionPill from '../../lib/Bills/BillPositionPill.svelte';

    /** "AB 10: Pupils: body shaming…" — split into the bill number and its title. */
    export let name: string;
    export let session = '';
    export let position: BillPosition | null = null;
    export let href: string;

    $: ({ billId, billTitle } = parseBillName(name));
</script>

<a
    {href}
    use:link
    class="group flex w-full items-start gap-4 bg-white px-4 py-3.5 text-left !no-underline transition-colors hover:bg-gray-50
        focus:outline-none focus-visible:relative focus-visible:z-10 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--vv-action-center-button-color,#2563eb)]"
    data-testid="bill-row"
>
    <span class="flex min-w-0 flex-1 flex-col gap-0.5 sm:flex-row sm:gap-4">
        <span class="shrink-0 pt-px text-sm tabular-nums text-gray-600 sm:w-24">{billId}</span>
        <span class="min-w-0 flex-1">
            <span class="line-clamp-2 text-sm text-gray-900 group-hover:text-[#1b75d0] group-hover:underline">{billTitle}</span>
            {#if session || position}
                <span class="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-gray-500 sm:mt-1">
                    {#if position}
                        <span class="sm:hidden"><BillPositionPill {position} /></span>
                    {/if}
                    {#if session}<span>{session}</span>{/if}
                </span>
            {/if}
        </span>
    </span>
    {#if position}
        <span class="hidden sm:block"><BillPositionPill {position} /></span>
    {/if}
</a>
